import { Routes } from '@angular/router';

import { CustomerPortalComponent } from 'src/app/modules/core/components/customer-portal/customer-portal.component';
import { ErrorPageComponent } from 'src/app/modules/core/components/error-page/error-page.component';

import { isLoggedInGuard } from 'src/app/modules/shared/guards/auth.guard';
import { hasConstructionUpdatesPostCloseGuard } from 'src/app/modules/shared/guards/construction-updates-post-close.guard';
import { contactInformationGuard } from 'src/app/modules/shared/guards/contact-information.guard';
import { nonRealtorPreviewGuard, previewRealtorDeepLinkGuard } from 'src/app/modules/shared/guards/non-realtor-preview.guard';
import { ROUTES } from 'src/app/modules/shared/constants/route-paths';
import { realtorAccessGuard } from 'src/app/modules/shared/guards/realtor-access.guard';
import { termsAndConditionsGuard } from 'src/app/modules/shared/guards/terms-and-conditions.guard';

const portalRoutes: Routes = [
	{
		path: ROUTES.Dashboard,
		loadChildren: () => import('./modules/dashboard/dashboard.routes').then(m => m.ROUTES)
	},
	{
		path: ROUTES.YourHome,
		loadChildren: () => import('./modules/your-home/your-home.routes').then(m => m.ROUTES),
	},
	{
		path: ROUTES.MessageCenter,
		loadChildren: () => import('./modules/message-center/message-center.routes').then(m => m.ROUTES)
	},
	{
		path: ROUTES.ConstructionProgress,
		loadComponent: () => import('src/app/modules/construction-progress/components/construction-progress/construction-progress.component').then(m => m.ConstructionProgressComponent),
		canMatch: [
			// Use the guard factory directly; it returns a canMatch guard function
			hasConstructionUpdatesPostCloseGuard()
		]
	},
	{
		path: ROUTES.ServiceRequests,
		loadChildren: () => import('./modules/service-requests/service-requests.routes').then(m => m.ROUTES),
		canMatch: [nonRealtorPreviewGuard]
	},
	{
		path: ROUTES.FinancialServices,
		loadChildren: () => import('./modules/financial-services/financial-services.routes').then(m => m.ROUTES)
	},
	{
		path: ROUTES.Resources,
		loadChildren: () => import('./modules/resources/resources.routes').then(m => m.ROUTES)
	},
	{
		path: ROUTES.ContactDetails,
		loadComponent: () => import('./modules/contact-details/components/contact-details/contact-details.component').then(m => m.ContactDetailsComponent),
		canMatch: [contactInformationGuard]
	},
	{
		path: ROUTES.RealtorAccess,
		loadChildren: () => import('./modules/realtor-access/realtor-access.routes').then(m => m.ROUTES),
		canMatch: [realtorAccessGuard]
	},
	{
		path: ROUTES.Realtor,
		loadChildren: () => import('./modules/realtor/realtor.routes').then(m => m.ROUTES),
		canActivate: [isLoggedInGuard]
	},
	{
		// #418853 Redirect to Dashboard page when navigating to base URL
		path: '',
		pathMatch: 'full',
		redirectTo: ROUTES.Dashboard
	},
	{
		path: '**',
		component: ErrorPageComponent
	}
];

export const routes: Routes = [
	// The style guide exists outside of the navigation wrapper
	{
		path: ROUTES.StyleGuide,
		loadChildren: () => import('./modules/style-guide/style-guide.routes').then(m => m.ROUTES)
	},
	{
		path: ROUTES.Error,
		component: ErrorPageComponent
	},
	// Preview realtor entry — must come before preview/:salesAgreementId to avoid 'realtor' matching as a salesAgreementId
	{
		path: `${ ROUTES.Preview }/${ ROUTES.Realtor }`,
		canActivate: [isLoggedInGuard, termsAndConditionsGuard],
		data: { isPreviewRealtor: true },
		loadComponent: () => import('./modules/shared/components/home-list/home-list.component').then(m => m.HomeListComponent)
	},
	{
		path: `${ ROUTES.Preview }/${ ROUTES.Realtor }/:salesAgreementId`,
		canActivate: [isLoggedInGuard, termsAndConditionsGuard, previewRealtorDeepLinkGuard],
		data: { isPreviewRealtor: true },
		component: CustomerPortalComponent,
		children: portalRoutes
	},
	{
		path: `${ ROUTES.Preview }/:salesAgreementId`,
		canActivate: [isLoggedInGuard, termsAndConditionsGuard],
		component: CustomerPortalComponent,
		children: portalRoutes
	},
	// All child components defined in this object will be wrapped by the side-menu and header
	{
		path: ROUTES.CustomerPortal,
		canActivate: [isLoggedInGuard, termsAndConditionsGuard],
		component: CustomerPortalComponent,
		children: portalRoutes
	},
	{
		path: '**',
		redirectTo: ROUTES.CustomerPortal
	}
];
